import React from 'react';
import WeekCard from './WeekCard';

export default class WeeklyJobResourceList extends React.Component {
    render() {
        const { weeklyJobResources, dateOverviews } = this.props;

        return (
            <>
                {weeklyJobResources.map((wjr) => {
                    const dateOverview = dateOverviews.find(
                        (d) => d.weekOfDate == wjr.weekOfDate
                    );

                    return (
                        <WeekCard
                            key={wjr.key}
                            wjr={wjr}
                            dateOverview={dateOverview}
                            {...this.props}
                        />
                    );
                })}
            </>
        );
    }
}
